import { AccountContext } from 'components/AccountContext';
import { useTelemedicina } from 'context/TelemedicinaContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const useModelCardsEspecialista = () => {
  const { user } = useContext(AccountContext);
  const navigate = useNavigate();
  const { setAgendamento } = useTelemedicina();
  const logado = user.loggedIn === true;
  return {
    navigate,
    setAgendamento,
    logado,
  };
};

export default useModelCardsEspecialista;
